import nextRound from "@/assets/audios/next_round.mp3";
import challenge from "@/assets/audios/challenge.wav";
import chat from "@/assets/audios/chat.wav";
import finish_challange from "@/assets/audios/finish_challange.wav";
import correct from "@/assets/audios/correct.wav";
import incorrect from "@/assets/audios/incorrect.wav";
import material_pick from "@/assets/audios/material_pick.wav";
import material_return from "@/assets/audios/material_return.wav";
import challenge_to_review from "@/assets/audios/challenge_to_review.wav";
import i18n from "@/utils/i18n";

type ToastAddFn = (message: Record<string, unknown>) => void;
let toastAdd: ToastAddFn | null = null;

function setToastInstance(toast: { add: ToastAddFn }) {
	toastAdd = toast.add.bind(toast);
}

function truncateMessage(text: string, max = 80) {
	const trimmed = text.trim();
	return trimmed.length > max ? `${trimmed.slice(0, max)}…` : trimmed;
}

const sounds ={
    challenge,
    chat,
    finish_challange,
    correct,
    incorrect,
    material_pick,
    material_return,
    challenge_to_review
}


function notificate() {
    try{
        navigator.vibrate([200, 500, 200])
    }
    catch{
        // not soported 
    }
    const player = document.getElementById("generalAudioPlayer");
    player.src = (nextRound);
    player.play();
}


function sound_alert(sound) {
    try{
        navigator.vibrate([1000, 500, 1000, 500, 2000]);
    }
    catch{
        // not soported 
    }

    const player = document.getElementById("generalAudioPlayer");
    player.src = (sounds[sound]);
    player.play();
}

function notify_new_chat_message(messageText?: string) {
	sound_alert("chat");

	const t = i18n.global.t;
	const detail = messageText
		? truncateMessage(messageText)
		: t("chat.new_message_detail");

	toastAdd?.({
		severity: "info",
		summary: t("chat.new_message_summary"),
		detail,
		life: 4000,
	});
}


export { notificate, sound_alert, notify_new_chat_message, setToastInstance };
